module.exports = __webpack_public_path__ + "img/case-user-ava1.630db58c.png";